(() => {
  function init(scope = document) {
    const selector = '[data-trustpilot-strip], .qpc-trustpilot--product, .qpc-trustpilot--drawer';
    const strips = [...scope.querySelectorAll(selector)];
    if (scope.matches?.(selector)) strips.unshift(scope);
    strips.forEach(strip => {
      if (strip.stripCleanup) return;
      const widget = strip.matches('.qpc-trustpilot') ? strip : strip.querySelector('.qpc-trustpilot--home');
      if (!widget) return;
      const resize = () => {
        widget.style.setProperty('--trustpilot-strip-scale', Math.min(1, widget.clientWidth / 360));
      };
      const observer = new ResizeObserver(resize);
      observer.observe(widget);
      resize();
      strip.stripCleanup = () => { observer.disconnect(); delete strip.stripCleanup; };
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-trustpilot-strip], .qpc-trustpilot--product, .qpc-trustpilot--drawer').forEach(strip => strip.stripCleanup?.());
  });
})();
